import { getAccounts, Account } from '../modules/accountant/core/_request'

export const VAT_TYPE_EXCLUDED = 'excluded'
export const VAT_TYPE_INCLUDED = 'included'
export const VAT_TYPE_NONE = 'none'

export const EXPENSE_TYPE_DEPOSIT = 'deposit_payment'
export const EXPENSE_TYPE_PURCHASE = 'purchase_record'
export const EXPENSE_TYPE_PURCHASE_CREDIT_NOTE = 'purchase_credit_note'
export const EXPENSE_TYPE_PURCHASE_DEBIT_NOTE = 'purchase_debit_note'
export const EXPENSE_TYPE_ALL = 'all'

export const DEFAULT_VAT_TYPE = VAT_TYPE_EXCLUDED

export enum IncomeDocumentTypes {
  QUOTATION = 'quotation',
  DEPOSIT = 'deposit',
  INVOICE = 'invoice',
  RECEIPT = 'receipt',
  DEBIT = 'debit',
  CREDIT = 'credit',
  BILLING = 'billing',
  TAX_INVOICE = 'tax-invoice',
  EXPENSE_PURCHASE_ORDER = 'expense-purchase-order',
  EXPENSE_PURCHASE_ASSET_ORDER = 'expense-purchase-asset-order',
  EXPENSE_REQUEST_PURCHASE_ORDER = 'expense-request-purchase-order',
  EXPENSE_DEPOSIT_PAYMENT = 'expense-deposit-payment',
  EXPENSE_PURCHASE_INVENTORY_RECORD = 'expense-purchase-inventory-record',
  EXPENSE_EXPENSE_RECORD = 'expense-expense-record',
  EXPENSE_PURCHASE_TAX_INVOICE = 'expense-purchase-tax-invoice',
  EXPENSE_PURCHASE_CREDIT_NOTE = 'expense-purchase-credit-note',
  EXPENSE_PURCHASE_DEBIT_NOTE = 'expense-purchase-debit-note',
  EXPENSE_COMBINED_PAYMENT_NOTE = 'expense-combined-payment-note',
}

export enum IncomeDocumentStateTypes {
  DRAFT = 'draft',
  APPROVED = 'approved',
  AWAIT_APPROVAL = 'await-approval',
  AWAIT_ACCEPT = 'await-accept',
  AWAIT_DEDUCT = 'await-deduct',
  AWAIT_RECEIPT = 'await-receipt',
  AWAIT_TAX_INVOICE = 'await-tax-invoice',
  ACCEPTED = 'accepted',
  DEDUCTED = 'deducted',
  RECEIVE_RECEIPT = 'receive-receipt',
  RECEIVE_TAX_INVOICE = 'receive-tax-invoice',
  AUTO_GENERATED = 'auto-generated',
  COMPLETELY = 'completely',
  OVERDUE = 'overdue',
  OUTSTANDING = 'outstanding',
  ISSUED = 'issued',
  INVOICE = 'invoice',
  PAID = 'paid',
  EXPIRED = 'expired',
  VOIDED = 'voided',
  RECURRING = 'recurring',
  PARTIAL = 'partial',
}

export enum DiscountType {
  FIXED,
  PERCENT,
}

export enum ReferenceType {
  REFER,
  NOT_REFER,
}

export const CHANNEL_OPTIONS = [
  {label: 'ออฟไลน์', value: 'offline'},
  {label: 'ออนไลน์ Shopee', value: 'shopee'},
  {label: 'ออนไลน์ Lazada', value: 'lazada'},
  {label: 'ออนไลน์ Tiktok', value: 'tiktok'},
]

export const VAT_TYPE_OPTIONS = [
  {label: 'แยกภาษี', value: VAT_TYPE_EXCLUDED},
  {label: 'รวมภาษี', value: VAT_TYPE_INCLUDED},
  {label: 'ไม่มี', value: VAT_TYPE_NONE},
]

export const EXPENSE_TYPE_OPTIONS = [
  {label: 'ใบจ่ายเงินมัดจำ', value: EXPENSE_TYPE_DEPOSIT},
  {label: 'บันทึกซื้อสินค้า/ค่าใช้จ่าย', value: EXPENSE_TYPE_PURCHASE},
]

export const EXPENSE_COMBINED_TYPE_OPTIONS = [
  {label: 'ใบจ่ายเงินมัดจำ', value: EXPENSE_TYPE_DEPOSIT},
  {label: 'บันทึกซื้อสินค้า/ค่าใช้จ่าย', value: EXPENSE_TYPE_PURCHASE},
  {label: 'รับใบลดหนี้', value: EXPENSE_TYPE_PURCHASE_CREDIT_NOTE},
  {label: 'รับใบเพิ่มหนี้', value: EXPENSE_TYPE_PURCHASE_DEBIT_NOTE},
  {label: 'ทั้งหมด', value: EXPENSE_TYPE_ALL},
]

export const VAT_OPTIONS = [
  {label: 'ไม่มี', value: 99},
  {label: '0%', value: 0},
  {label: '7%', value: 7},
]

export const TAX_OPTIONS = [
  {label: 'ไม่มี', value: 0},
  {label: '.75%', value: 0.75},
  {label: '1%', value: 1},
  {label: '1.5%', value: 1.5},
  {label: '2%', value: 2},
  {label: '3%', value: 3},
  {label: '5%', value: 5},
  {label: '7%', value: 7},
  {label: '10%', value: 10},
  {label: 'กำหนดเอง', value: 99},
]

// Function to get product payment account options from API
export const getProductPaymentAccountOptions = async (): Promise<{label: string, value: string}[]> => {
  try {
    const response = await getAccounts()
    const accounts: Account[] = Array.isArray(response?.data) ? response.data : (Array.isArray(response) ? response : [])
    
    return accounts.map((account: Account) => ({
      label: `${account.code} - ${account.name}`,
      value: account.code
    }))
  } catch (error) {
    console.error('Error fetching accounts:', error)
    // Fallback to original static data if API fails
    return []
  }
}

// Keep the original constant for backward compatibility (deprecated)
export const PRODUCT_PAYMENT_ACCOUNT_OPTIONS = [
  {label: 'เงินรับล่วงหน้า - เงินมัดจำ', value: '212104'},
  {label: 'เงินจ่ายล่วงหน้า - เงินมัดจำ', value: '115104'},
]

export const PAYMENT_METHOD_OPTION = [
  {label: '+ เพิ่มช่องทาง', value: 'create'},
  {label: 'เช็ค', value: 'cheque', id: 'cheque'},
]

export const BANK_LIST_ONLY_OPTIONS = [
  {label: 'ธนาคารกสิกรไทย', value: 'kbank'},
  {label: 'ธนาคารกรุงเทพ', value: 'bbl'},
  {label: 'ธนาคารไทยพาณิชย์', value: 'scb'},
]

export const BANK_LIST_OPTIONS = [{label: 'เงินสด', value: 'cash'}, ...BANK_LIST_ONLY_OPTIONS]

export const DOCUMENT_TYPE_OPTION = [
  {label: 'ใบรับเงินมัดจำ', value: 'deposit'},
  {label: 'ใบแจ้งหนี้', value: 'invoice'},
  {label: 'ใบเสร็จรับเงิน', value: 'receipt'},
]

export const CREDIT_NOTE_REASON_OPTION = [
  {
    label: 'ลดราคาสินค้า',
    value: 'credit-note-reason-1',
    message: 'เนื่องจากผิดจากที่ตกลงกัน ชำรุดเสียหาย ไม่ครบ หรือคำนวณราคาผิด',
  },
  {
    label: 'ลดราคาค่าบริการ',
    value: 'credit-note-reason-2',
    message: 'เนื่องจากผิดจากที่ตกลงกัน ให้บริการไม่ครบ หรือคำนวณราคาผิด',
  },
  {
    label: 'ได้รับคืนสินค้า',
    value: 'credit-note-reason-3',
    message: 'เนื่องจากผิดจากชำรุดเสียหาย ไม่ครบ ไม่ตรงตามตัวอย่าง หรือไม่ตรงตามคำบรรยาย',
  },
  {
    label: 'จ่ายเงินชดเชย',
    value: 'credit-note-reason-4',
    message: 'ให้แก่ผู้ซื้อสินค้า หรือผู้รับบริการตามข้อผูกพัน/ข้อตกลงกัน',
  },
  {
    label: 'จ่ายเงินคืนเงินล่วงหน้า เงินมัดจำ เงินประกัน เงินจอง',
    value: 'credit-note-reason-5',
    message: 'ให้แก่ผู้ซื้อสินค้า หรือผู้รับบริการตามข้อผูกพัน/ข้อตกลงกัน',
  },
  {
    label: 'ได้รับคืนสินค้า หรือแลกเปลี่ยนสินค้า',
    value: 'credit-note-reason-6',
    message: 'ระหว่างผู้ประกอบการ VAT ด้วยกัน',
  },
  {
    label: 'ได้รับคืนสินค้า หรือแลกเปลี่ยนสินค้า',
    value: 'credit-note-reason-7',
    message: 'ระหว่างผู้ขายกับลูกค้า (เฉพาะภายในเวลาอันเหมาะสม)',
  },
  {label: 'บอกเลิกบริการ', value: 'credit-note-reason-8', message: 'เนื่องจากผิดจากที่ตกลงกัน'},
  {
    label: 'บอกเลิกบริการ',
    value: 'credit-note-reason-9',
    message: 'เนื่องจากไม่ได้มีการให้บริการตามสัญญา',
  },
  {label: 'อื่นๆ', value: 'etc'},
]

export const CREDIT_NOTE_ITEM_VOLUME_OPTION = [
  {label: 'ทุกรายการ', value: 1},
  {label: 'เฉพาะรายการ', value: 0},
]

export const CREDIT_NOTE_RETURN_ITEM_OPTION = [
  {label: 'รับสินค้าคืน', value: 1},
  {label: 'ไม่รับสินค้าคืน', value: 0},
]

export const DEBIT_NOTE_REASON_OPTION = [
  {
    label: 'เพิ่มราคาสินค้า',
    value: 'debit-note-reason-1',
    message: 'เพิ่มราคาสินค้า เนื่องจากสินค้าเกินกว่าจำนวนที่ตกลงกัน คำนวนราคาต่ำกว่าความเป็นจริง',
  },
  {
    label: 'เพิ่มราคาบริการ',
    value: 'debit-note-reason-2',
    message: 'เพิ่มราคาบริการ เนื่องจากให้บริการเกินกว่าที่กำหนด คำนวนราคาต่ำกว่าความเป็นจริง',
  },
  {label: 'อื่นๆ', value: 'etc'},
]

export const DEBIT_NOTE_ADDITIONAL_ITEM_OPTION = [
  {label: 'ส่งสินค้าเพิ่ม', value: 1},
  {label: 'ไม่ส่งสินค้าเพิ่ม', value: 0},
]

export const DEPARTMENT_OPTIONS = [
  {label: 'บริหาร', value: 1},
  {label: 'จัดการสนับสนุน', value: 2},
  {label: 'การขาย', value: 3},
  {label: 'การตลาด', value: 4},
  {label: 'บัญชี', value: 5},
  {label: 'การเงิน', value: 6},
  {label: 'บุคคล', value: 7},
  {label: 'ผลิต', value: 8},
  {label: 'จัดซื้อ', value: 9},
  {label: 'ทั่วไป', value: 10},
]

export const TAX_EXPENSE_OPTIONS = [
  {label: 'ค่าใช้จ่ายต้องห้าม', value: 1},
  {label: 'รายจ่ายที่หักภาษีได้เพิ่ม', value: 2},
  {label: 'รอพิจารณา', value: 3},
]

export const DEDUCT_DOCUMENT_TYPE_OPTIONS = [
  {label: 'ใบจ่ายเงินมัดจำ', value: IncomeDocumentTypes.EXPENSE_DEPOSIT_PAYMENT},
  {label: 'ใบลดหนี้', value: IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE},
  {label: 'ใบเพิ่มหนี้', value: IncomeDocumentTypes.EXPENSE_PURCHASE_DEBIT_NOTE},
]

export const DEDUCT_DOCUMENT_INCOME_TYPE_OPTIONS = [
  {label: 'ใบรับเงินมัดจำ', value: IncomeDocumentTypes.DEPOSIT},
  {label: 'ใบลดหนี้', value: IncomeDocumentTypes.CREDIT},
  {label: 'ใบเพิ่มหนี้', value: IncomeDocumentTypes.DEBIT},
]

export const PAYMENT_ADJUSTMENT_OPTIONS = [
  {label: 'หักเงินที่ต้องรับ', value: -1},
  {label: 'เพิ่มเงินที่ต้องรับ', value: 1},
]
export const EXPENSE_PAYMENT_ADJUSTMENT_OPTIONS = [
  {label: 'หักเงินที่ต้องจ่าย', value: -1},
  {label: 'เพิ่มเงินที่ต้องจ่าย', value: 1},
]

export enum DEBT_REDUCTION_REASON {
  PRODUCT_PRICE_REDUCTION = 'product_price_reduction',
  SERVICE_PRICE_REDUCTION = 'service_price_reduction',
  PRODUCT_RETURN = 'product_return',
  COMPENSATION_PAYMENT = 'compensation_payment',
  ADVANCE_REFUND = 'advance_refund',
  BUSINESS_EXCHANGE = 'business_exchange',
  CUSTOMER_EXCHANGE = 'customer_exchange',
  SERVICE_CANCELLATION_AGREEMENT = 'service_cancellation_agreement',
  SERVICE_CANCELLATION_BREACH = 'service_cancellation_breach',
  OTHER = 'other',
}

export enum DEBT_ADDITION_REASON {
  PRODUCT_PRICE_INCREASE = 'product_price_increase',
  SERVICE_PRICE_INCREASE = 'service_price_increase',
  OTHER = 'other',
}

export enum DEBT_REDUCTION_SCOPE {
  ALL_ITEMS = 'all_items',
  SPECIFIC_ITEMS = 'specific_items',
}

export enum PRODUCT_RETURN_OPTION {
  ALL_RETURN = 'all_return',
  NO_RETURN = 'no_return',
}

export enum PRODUCT_RECEIVE_OPTION {
  RECEIVE_MORE = 'receive_more',
  NOT_RECEIVE_MORE = 'not_receive_more',
}
